import { underscored } from 'underscore.string';

export default function getDefaultName(entity) {
  return `summary_tab_${underscored(entity)}`;
}
